import { GenericObject } from '../../types/genericTypes';

export const validateEmail = (email: string, isMember = false) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const reToBackend = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (isMember) {
    return reToBackend.test(String(email).toLowerCase());
  }
  return re.test(String(email).toLowerCase());
};

export const isEmptyObject = (obj: GenericObject) => {
  return Object.keys(obj).length === 0;
};

export const isEqualObject = (obj1: GenericObject, obj2: GenericObject) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const validateDomain = (domain: string) => {
  const re = /@[\w.-]+\.[a-zA-Z]+/;
  return re.test(domain);
};
